var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowup = function SvgArrowup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M.34 9.127c.45.427 1.173.423 1.616-.01L8 3.222l6.044 5.895a1.174 1.174 0 0 0 1.616.01c.45-.427.454-1.124.01-1.556L8.814.883A1.17 1.17 0 0 0 8 .556c-.306 0-.599.117-.813.327L.33 7.57a1.07 1.07 0 0 0 .01 1.556"
  })));
};
export default SvgArrowup;